import type { UIScope } from 'district-ui-client/domain/ui-scope'

/**
 * For use when requesting student_events endpoints for legacy reports.
 * Legacy report requests are scoped to a single school or district.
 */
export type StatsScope = SchoolScope | DistrictScope

export interface SchoolScope {
  scope: 'school'
  ids: string[]
}

export interface DistrictScope {
  scope: 'district'
  ids: string[]
}

export function toStatsScope(uiScope: UIScope): StatsScope {
  return {
    scope: uiScope.scope,
    ids: [uiScope.id],
  }
}
